import { connect } from 'react-redux';
import { ManageEquipmentComponent } from './manage-equipment.component';
import { AppState } from '../../app.state';
import {
  setLastEquipment,
  addToMap,
  setEquipView,
  setEquipPage,
  setEquipPageSize,
} from '../dashboard.actions';

export const ManageEquipment = connect(
  (sState: AppState) => ({ sState }),
  {
    setLastEquipment,
    addToMap,
    setEquipView,
    setEquipPage,
    // AER-1612 follow-up: persist user-chosen page size.
    setEquipPageSize,
  }
  //@ts-ignore
)(ManageEquipmentComponent as any) as unknown as typeof ManageEquipmentComponent;
